// extracted by mini-css-extract-plugin
export default {"pagination":"lHfjMx","hidden":"KTyA_W","link":"UtUmot","active":"K4yapU","svg":"zfeUEF","prev":"Z8E_yS","link-active":"u9XL8l","linkActive":"u9XL8l"};